import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { ProposalDiagnogisComponent } from './proposal-diagnosis.component';
import { ManualDiagnosisComponent } from './manual-diagnosis/manual-diagnosis.component';
import { MATERIALS } from '../../app.materials';
import { BaseModule } from '../../shared/base.module';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { PerfectScrollbarConfigInterface, PerfectScrollbarModule, PERFECT_SCROLLBAR_CONFIG } from 'ngx-perfect-scrollbar';
import { TabsModule } from 'ngx-bootstrap/tabs';
import { PopoverModule } from 'ngx-bootstrap/popover';
import { ModalModule } from 'ngx-bootstrap/modal';
import { AccordionModule } from 'ngx-bootstrap/accordion';
import {CollapseModule} from 'ngx-bootstrap/collapse';
import { DialogModule } from '../../dialog/dialog.module';
import { FeelingSelectionModule } from '../feeling-selection/feeling-selection.module';
import { FeelingListSelectionModule } from '../feeling-list-selection/feeling-list-selection.module';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
    suppressScrollX: true,
};
@NgModule({
    imports: [
        MATERIALS,
        BaseModule,
        CommonModule,
        RouterModule,
        TooltipModule.forRoot(),
        PerfectScrollbarModule,
        TabsModule.forRoot(),
        PopoverModule.forRoot(),
        ModalModule.forRoot(),
        CollapseModule.forRoot(),
        DialogModule,
        AccordionModule.forRoot(),
        FeelingSelectionModule,
        FeelingListSelectionModule
    ],
    declarations: [
        ProposalDiagnogisComponent,
        ManualDiagnosisComponent
    ],
    exports: [
        ProposalDiagnogisComponent,
        ManualDiagnosisComponent
    ],
    providers: [
        {
            provide: PERFECT_SCROLLBAR_CONFIG,
            useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
        }
    ]
})

export class ProposalDiagnosisModule {

}
